import { useEffect, useRef, useState } from "react";
import SyOverlayContainer from "../../../../../shared/components/sy-overlay-container";
import styleSheet from "../style.module.scss";
import NotificationCard from "../notification-card";
import { notifyData } from "../config";
import { useSelector } from "react-redux";
import { getNotificationDetails } from "../../../../../feature/notification-slice";
import { useTranslation } from "react-i18next";

const NotificationTab = (props: any) => {
    const scrollRef = useRef<HTMLDivElement | null>(null);
    const [loading, setLoading] = useState<any>(null);
    const { open ,clearNotification,onClickNotifyCard} = props;
    const notificationSlice = useSelector(getNotificationDetails);
     const { t } = useTranslation();
     
    const handleReachBottom = () => {
  
       
      };
    
      useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;
    
        const onScroll = () => {
          const { scrollTop, scrollHeight, clientHeight } = container;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // 5px tolerance
          if (isAtBottom) {
            handleReachBottom();
          }
        };
    
        container.addEventListener("scroll", onScroll);
        return () => container.removeEventListener("scroll", onScroll);

      }, []);
    
    return (
      <>
        <div className="position-absolute bottom-0 end-0 " onClick={(e) => e.stopPropagation()}>
          <SyOverlayContainer
            open={open}
            direction={"left"}
            background="dark"
            height="notic"
          >
            <div className={`${styleSheet.notic}  px-2  h-100 sy-scroll-y position-relative`}    ref={scrollRef}>
              <div className={`${styleSheet.header} py-1 d-flex justify-content-between mohave text-white font-20 text-info  position-sticky top-0 z-1`}>
                <p className="pointer ">  {t("notifications")}</p>
                <p className="pointer" onClick={()=>clearNotification(null)}> {t("clear_all")}</p>
              </div>
              <div className="opacity-75 ">
                {notificationSlice?.notificationData?.map((notic:any)=>{
                    return(
                        <NotificationCard notic={notic} onClickNotifyCard={onClickNotifyCard} clearNotification={clearNotification}/>
                    )
                })}

              </div>
            </div>
          </SyOverlayContainer>
        </div>
      </>
    );

}

export default NotificationTab